
import React from 'react'

import { IGeneralData } from '@np/np_webcomponentlib'

import { optionEnum } from '../../shared/entityOperations/EntityFormTypes'

import { Column, ListFields } from '@np/np_webcomponentlib'

import { EntityFormProps } from '../../shared/entityOperations/EntityFormTypes'

import { ColumnWithCopyToClipboard } from '../../shared/entityOperations/EntityOperationsCustomFC'
import { TypeBusinessEnum, TypeCurrencyEnum } from '../../shared/MasterData/MasterDataTypes'







export interface EntityType {
  [key: string]: string | number | Date | boolean | TypeCurrencyEnum | null | undefined ; // Допускаем, что значения могут быть строками или числами
  typeBusiness?: TypeBusinessEnum;
    name: string;
    fullName: string;
    techChat: string;
    idrfGeo: string;
    currencyBalance: TypeCurrencyEnum;
    currencyPayment: TypeCurrencyEnum;
    contractText?: string;
    contractNumber?: string;
    contractDate?: Date;
    taxNumber?: string;
    ogrn?: string;
    kpp?: string;
    legalAddress?: string;
    factAddress?: string;
    contactPhone?: string;
    contactEmail: string;
    dateBlocked?: Date;
    noteText: string;
    redirectGeneralURL?: string;
    redirectSuccessURL?: string;
    redirectFailURL?: string;
    webHook?: string;
    receiptChatId?: string;
    receiptForwardEnabled?: boolean;
    providerURLHost: string;
    startRandomization?: Date;
    maxForwardRandomization: number;
    idSourceRate?: string | null;

    percentageOfExchangeRateSource: number;

    percentExchangeRatePayOut: number


    monoBankPaymentMethod?: string | null;

    maxCountParallelRequest: number;
    maxMillisecondRequest: number;
    listWhiteIP: string;
  
}




export interface DataEntityType extends IGeneralData, EntityType {

}

export interface DataEntityTypeViewModel {
  
}


//Расширенные данные для передачи сущности с предустановленными значениями для создания
export interface EntityFormPropsWithType extends EntityFormProps {
  initEntityProps: EntityType | undefined
}

// export const getEntityBylistVals = (listFields: ListFields[], entity: EntityType): EntityType => {
//   // Создаем новый объект на основе initEntity, чтобы не изменять оригинал
//   const updatedEntity: EntityType = { ...entity };

//   listFields.forEach(field => {
//     // Проверяем, существует ли такое поле в initEntity
//     if (field.fieldName in updatedEntity) {
//       // Устанавливаем первое значение из listVal, если оно существует
//       const valueToSet = field.listVal.length > 0 ? field.listVal[0] : '';
//       updatedEntity[field.fieldName] = valueToSet;
//     }
//   });

//   return updatedEntity;
// }


export const initEntity: EntityType = {
    name: "",
    techChat: "",
    fullName: "",
    contactEmail: "",
    noteText: "",
    idrfGeo: "00000000-0000-0000-0000-000000000000",
    currencyBalance: TypeCurrencyEnum.NOTSET,
    currencyPayment: TypeCurrencyEnum.NOTSET,
    providerURLHost: "",
    receiptChatId: "",
    receiptForwardEnabled: false,
    maxForwardRandomization: 0,
    idSourceRate: null,
    monoBankPaymentMethod: null,

    percentageOfExchangeRateSource: 0,
    percentExchangeRatePayOut: 0,
    
    maxCountParallelRequest: 0,
    maxMillisecondRequest: 0,
    listWhiteIP: ""
}


export const columnsForChoose: Column[] = [

  {
    title: '',
    listFields: null,
    type: 'custom',
    custom: (data: DataEntityType) => (

      <ColumnWithCopyToClipboard data={data.idUnique} title='fe fe-edit eventIcom'></ColumnWithCopyToClipboard>
    ),
    key: 1,
    withFilter: null,
    class: "eventColumn"
  },

  {
    title: 'Наименование',
    listFields: {
      fieldName: 'name',
      comparison: 'containsIgnoreCase',
      listVal: [''],
    },
    key: 5,
    withFilter: 'all',
  },




  {
    title: 'Дата создания',
    listFields: {
      fieldName: 'dateAdded',
      comparison: 'containsStrong',
      listVal: [''],
    },
    type: 'date-time',
    key: 100,
    withFilter: 'onlySorted',
    class: "dateTtimeColumn"
  },


  {
    title: 'Дата изменения',
    listFields: {
      fieldName: 'dateUpdated',
      comparison: 'containsStrong',
      listVal: [''],
    },
    type: 'date-time',
    key: 101,
    withFilter: 'onlySorted',
    class: "dateTtimeColumn"
  },



]



export const columnsRate: Column[] = [

      

  {
    title: '',
    listFields: null,
    type: 'custom',
    custom: (data: DataEntityType) => (

      <ColumnWithCopyToClipboard data={data.idUnique} title='fe fe-edit eventIcom'></ColumnWithCopyToClipboard>
    ),
    key: 1,
    withFilter: null,
    class: "eventColumn"
  },



  {
    title: 'Дата создания',
    listFields: {
      fieldName: 'dateAdded',
      comparison: 'containsStrong',
      listVal: [''],
    },
    type: 'date-time',
    key: 100,
    withFilter: 'onlySorted',
    class: "dateTtimeColumn"
  },


  {
    title: 'Наименование',
    listFields: {
        fieldName: 'title',
        comparison: 'containsIgnoreCase',
        listVal: [''],
    },
    key: 9,
    withFilter: 'all',
}
]


